import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useContracts = () => {
  return useSelector((state: RootState) => state.contracts.contracts) || [];
};
